
<!--#APARTMENT_INFO - #1243: HIỆN THỰC THÊM CHỨC NĂNG ĐỔI PHÒNG OR COPY THÔNG TIN BOOKING -->
<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-update-apartment-info">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title">{{ getTitle() }}</h1>
          </div>
          <div class="modal-body">
            <b-form>
              <!-- <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('modal_update_apartment_info.room')"
                  >
                    <div class="form-group">
                      <div>
                        <b-form-select
                          :options="apartment_rooms"
                          v-model="apartment.rom_apartment_id_changed"
                          class="form-control"
                          @change="onChangeApartmentRoom"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div> -->
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <!-- purpose_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('apartment.apartment_code')"
                  >
                    <div class="form-group">
                      <leaseback-select-option-apartment-custom
                        :data="apartment_rooms"
                        @clickOnItem="onChangeApartmentRoom"
                      />
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <!-- purpose_name -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('modal_update_apartment_info.package_service')"
                  >
                    <div class="form-group">
                      <leaseback-select-option-package-custom
                        ref="selectOptionPackageCustom"
                        @package-onemonth-elements="onPackageOneMonthObject"
                        @package-current-elements="onPackageCurrent"
                        @clickOnItem="onChangeSelect"
                        :package_id="package_id"
                        :apartment_id="apartment_id"
                        :title="setTitleService"
                      />
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <!-- amount -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('modal_update_apartment_info.service_start_e')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('modal_update_apartment_info.service_start_e')"
                          type="number"
                          v-model="apartment.electric_value"
                          class="form-control"
                          @change="onElectric"
                          v-on:keyup="onElectric"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <!-- amount -->
                  <b-form-group
                    label-size="sm"
                    label-for="input-sm"
                    :label="$t('modal_update_apartment_info.service_start_w')"
                  >
                    <div class="form-group">
                      <div>
                        <input
                          :placeholder="$t('modal_update_apartment_info.service_start_w')"
                          v-model="apartment.water_value"
                          type="number"
                          class="form-control"
                          @change="onWater"
                          v-on:keyup="onWater"
                        />
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="editOrAdd(null)"
              :class="'btn btn-primary btn-sm pull-right'"
            >{{ $t("common.save") }}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{ $t("common.back") }}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
// import i18n from "../lang";
// import constantsData from "../lib/constantsData";

import LeaseBackSelectOptionPackageCustom from "@/components/SelectOptionPackageCustom";
import LeaseBackSelectOptionApartmentCustom from '@/components/SelectOptionApartmentCustom'

export default {
  name: "lte-modal",
  data() {
    return {
      package_id: 0,
      apartment_id: 0,
      apartment_rooms: [],
      rom_apartment_id_changed: null,
      id: "",
      apartment: {
        id: 0,

        pkg: 0,
        packageOneMonthObject: "",
        packageCurrent: "",

        rom_apartment_id_changed: null,
        electric_value: 0,
        water_value: 0
      },

      options: {
        format: "DD/MM/YYYY",
        useCurrent: true
      },
      typeUpdate: null,

      callBackFrom: "",

      setTitleRoom: "modal_update_apartment_info.room",
      setTitleService: "modal_update_apartment_info.package_service"
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_AVAILABLE_APARTMENT_DATA"
    ])
  },
  methods: {
    onElectric: function(electric_value) {},
    onWater: function(water_value) {},
    onPackageOneMonthObject: function(objPackageOneMonth) {
      this.apartment.packageOneMonthObject = objPackageOneMonth;
    },
    onPackageCurrent: function(objPackageOneMonth) {
      this.apartment.packageCurrent = objPackageOneMonth;
    },
    onChangeSelect: function(pkg) {
      this.apartment.pkg = pkg;
    },

    getTitle() {
      return this.$t("modal_update_apartment_info.title");
    },
    // with from
    // BOOKING
    setCallBackFrom(from) {
      this.callBackFrom = from;
    },
    setValueDefault(object_data_default) {
      this.getAvailableApartmentList();
    },

    async submit(input_id) {
      $("#modal-update-apartment-info").modal("show");
    },

    editOrAdd: function(status_booking) {
      if (this.apartment.rom_apartment_id_changed == null) {
        alert("Vui Lòng Chọn Phòng")
        return
      } else if (this.apartment.pkg == 0) { 
        alert("Vui Lòng Chọn Gói")
        return
      }
      this.$emit("callbackUpdateApartmentInfoSuccess", this.apartment);
      $("#modal-update-apartment-info").modal("hide");

      this.SUCCESS_TOAST();
    },
    onShowModalConfirm: function(type) {
      this.typeUpdate = type;
      $("#modal-confirm").modal("show");
    },
    updateDateCheckinCheckout: function() {
      this.disabledCheckin = false;
    },
    closeModal: function() {
      $("#modal-update-apartment-info").modal("hide");
      this.disabledCheckin = true;
    },
    closeConfirmModal: function() {
      $("#modal-confirm").modal("hide");
    },

    onChangeApartmentRoom: function(item) {
      this.apartment.rom_apartment_id_changed = item.value
      let option = this.apartment_rooms.filter(v => {
        return this.apartment.rom_apartment_id_changed == v.value
      })[0]
      let filter = {
        params: {
          bedrooms: option.bedroom_count
        }
      }
      this.$refs.selectOptionPackageCustom.getPackages(filter)

      this.getApartmentMeterDevices(this.apartment.rom_apartment_id_changed)
    },
    getAvailableApartmentList: async function() {
      const filter = {
        params: {
          page: 1,
          apt_type: 2,
          apartment_code: "",
          from_size: "",
          to_size: "",
          owner_resident: "",
          status: [],
          checkin_datetime: utils.formatSqlDate(this.$route.query.checkin_datetime, this.options.format, "DD/MM/YYYY"),
          checkout_datetime: utils.formatSqlDate(this.$route.query.checkout_datetime, this.options.format, "DD/MM/YYYY"),
          absc: []
        }
      };

      this.apartment_rooms = [
        {
          value: null,
          text: "Đang Tìm Căn Hộ Trống...",
          disabled: true
        }
      ];

      await this.GET_AVAILABLE_APARTMENT_LIST(filter).then(
        function(res) {
          let result = res.data;
          let apartment_rooms = [
            // {
            //   value: null,
            //   text: "---"
            // }
          ];
          result.forEach(apartment => {
            let item = {
              value: apartment.id,
              text: apartment.apartment_code,
              bedroom_count: apartment.bedroom_count,
              size: apartment.size
            };
            apartment_rooms.push(item);
          });
          this.apartment_rooms = apartment_rooms;
        }.bind(this)
      );
    },

    getApartmentMeterDevices: function(apartment_id) {
      let apt_id = apartment_id || this.apartment_id
      const data = {
        id: apt_id
      };
      this.GET_APARTMENT_METERDEVICES(data).then(
        function(res) {
          res.forEach(v => {
            if (v.property_type === 1) {
              // Điện
              this.apartment.electric_value = v.amount;
              this.apartment_bookings.start_e = v.amount;
            } else if (v.property_type === 2) {
              // Nước
              this.apartment.water_value = v.amount;
              this.apartment_bookings.start_w = v.amount;
            }
          });
        }.bind(this)
      );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_APARTMENT_METERDEVICES",
      "GET_AVAILABLE_APARTMENT_LIST"
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert,
    "leaseback-select-option-package-custom": LeaseBackSelectOptionPackageCustom,
    "leaseback-select-option-apartment-custom": LeaseBackSelectOptionApartmentCustom
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LTEModalUpdateApartmentInfo.vue